enum TransitionDialogFields {
	MODE = "mode",
	STYLE = "style",
	DIRECTION = "direction",
	DURATION = "duration",
	AUTO_SCROLL = "auto_scroll",
	SCROLL_TIME = "scroll_time",
	FLY_OPAQUE = "fly_opaque",
	FLY_SCALE = "fly_scale",
	PAGERANGE = "pagerange"
}

export default TransitionDialogFields;